import React from "react";

const FormInput = ({
  id,
  label,
  value = "",
  onChange,
  disabled = false,
  invalid = false,
  placeholder = "",
  required = false,
  break_word = false,
  onZipSearch,
  labelPosition = "left", // NEW: left | top
}) => {
  const isTop = labelPosition === "top";

  return (
    <div
      className={`w-full mb-2 ${
        isTop
          ? "flex flex-col gap-1"
          : `flex items-start ${disabled ? "gap-2" : "gap-4"}`
      }`}
    >
      {label && (
        <label
          htmlFor={id}
          className={`text-base ${
            disabled ? "font-small" : "font-medium"
          } text-black
          ${!isTop ? "pt-2" : ""}
          ${break_word ? "" : "whitespace-nowrap flex-shrink-0"}`}
        >
          {label}
          {required && <span className="text-red-500">*</span>}
        </label>
      )}

      {disabled ? (
        <div
          id={id}
          className="min-w-[200px] px-3 py-1 bg-slate-50 border-0 border-b-2 text-base font-small text-black border-b-gray-300 rounded-md"
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
          }}
        >
          {value || placeholder}
        </div>
      ) : id === "zip" ? (
        <div className="relative min-w-[200px]">
          <textarea
            id={id}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            className={`w-full px-3 py-2 pr-10 text-base font-medium text-black rounded-md resize-none min-h-[3rem]
              ${
                invalid
                  ? "border-b-red-600 bg-red-50 ring-2 ring-red-300 focus:ring-red-400"
                  : "bg-slate-50 border-0 border-b-2 border-b-gray-300"
              }`}
          />
          <button
            type="button"
            onClick={onZipSearch}
            className="absolute right-2 top-2 p-1 text-blue-500 hover:text-blue-700"
          >
            <i className="fas fa-search"></i>
          </button>
        </div>
      ) : (
        <textarea
          id={id}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`min-w-[200px] px-3 py-2 text-base font-medium text-black rounded-md resize-y min-h-[3rem]
            ${
              invalid
                ? "border-b-red-600 bg-red-50 ring-2 ring-red-300 focus:ring-red-400"
                : "bg-slate-50 border-0 border-b-2 border-b-gray-300"
            }`}
        />
      )}
    </div>
  );
};

export default FormInput;
